export default __webpack_public_path__ + "static/media/CLICHY (28 sur 176).2e55a8f5.jpg";